import React from 'react';
import { Phone, Send, CheckCircle2, Zap } from 'lucide-react';
import { Button } from '../ui/button';

export const PromoSection = () => {
  return (
    <section id="promo-section" data-testid="promo-section" className="py-20 bg-[#0A0E27] relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-[300px] h-[300px] bg-[#0066FF]/10 rounded-full blur-[100px]" />
        <div className="absolute bottom-0 right-1/4 w-[300px] h-[300px] bg-[#00D9FF]/10 rounded-full blur-[100px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-5xl mx-auto bg-white/5 backdrop-blur-md rounded-3xl overflow-hidden border border-white/10 shadow-2xl">
          <div className="bg-gradient-to-r from-[#0066FF] to-[#00D9FF] text-white py-6 px-8">
            <div className="flex items-center justify-between">
              <div>
                <span className="inline-block bg-white/20 text-white px-4 py-1 rounded-full text-sm font-bold mb-3">
                  LIMITED TIME OFFER
                </span>
                <h2 className="text-2xl md:text-3xl font-bold">Ballito Aircon Service Special – R499</h2>
              </div>
              <div className="hidden md:block">
                <Zap className="w-16 h-16 text-white/30" />
              </div>
            </div>
          </div>

          <div className="p-8 md:p-12">
            <div className="mb-8">
              <h3 className="text-2xl font-bold text-white mb-4">Limited-Time Aircon Service Special</h3>
              <p className="text-base md:text-lg text-gray-400 leading-relaxed">
                Get your air conditioner professionally serviced before peak season. Prevent breakdowns, improve performance, and extend the life of your unit.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8 mb-8">
              <div>
                <h4 className="text-lg font-bold text-white mb-4 flex items-center">
                  <CheckCircle2 className="w-5 h-5 text-[#00D9FF] mr-2" />
                  What's Included:
                </h4>
                <ul className="space-y-3">
                  {['Full system inspection', 'Electrical safety check', 'Condenser clean', 'Drain inspection', 'Performance test'].map((item, i) => (
                    <li key={i} className="flex items-start">
                      <CheckCircle2 className="w-5 h-5 text-[#00D9FF] mr-3 flex-shrink-0 mt-0.5" />
                      <span className="text-gray-300 font-medium">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-white/5 border border-white/10 rounded-xl p-6">
                <div className="text-center mb-6">
                  <div className="text-5xl font-black bg-gradient-to-r from-[#00D9FF] to-[#0066FF] text-transparent bg-clip-text mb-2">R499</div>
                  <div className="text-gray-400">Professional Service</div>
                </div>
                <div className="space-y-3">
                  <Button size="lg" className="w-full bg-gradient-to-r from-[#0066FF] to-[#00D9FF] hover:from-[#0052CC] hover:to-[#00B8D4] text-white text-lg py-6 font-bold" data-testid="promo-call-btn">
                    <a href="tel:0644505026" className="flex items-center justify-center space-x-2">
                      <Phone className="w-5 h-5" />
                      <span>Call to Book: 064 450 5026</span>
                    </a>
                  </Button>
                  <Button size="lg" className="w-full bg-white/10 border border-white/20 text-white hover:bg-white/20 text-lg py-6" data-testid="promo-whatsapp-btn">
                    <a href="https://wa.me/27644505026?text=Hi%2C%20I%27d%20like%20to%20book%20the%20R499%20aircon%20service%20special" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center space-x-2">
                      <Send className="w-5 h-5" />
                      <span>WhatsApp to Book</span>
                    </a>
                  </Button>
                </div>
                <div className="mt-4 text-center">
                  <span className="text-red-400 font-semibold text-sm">Limited bookings available this month</span>
                </div>
              </div>
            </div>

            <div className="bg-white/5 border border-white/10 p-4 rounded-lg">
              <p className="text-sm text-gray-500">
                <strong className="text-gray-400">Note:</strong> Gas top-ups and repairs quoted separately if required. This special applies to standard residential split AC units in Ballito and surrounding areas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
